<app-home-widget>
  <div class="item-container">
    <div class="scroll-container">
      @for (item of items; track item) {
        @if (!item.isDisabled || !item.isDisabled()) {
          <div
            (click)="item.clickAction()"
            class="sidebar-item"
            [ngClass]="{ active: item.isActive && item.isActive() }">
            <fa-icon [icon]="item.icon" size="2x"></fa-icon>
            <div class="title-container">
              <span class="title">{{ "admin.sidebar." + item.key | translate }}</span>
            </div>
          </div>
        }
      }
    </div>
  </div>
</app-home-widget>
